import * as types from './types';
import createMetadataAPIReducer from '../../utils/api-metadata-reducer';

const initialState = {
  byId: {},
  ids: [],
  lastError: null,
  error: null,
  lastFetch: null,
  loading: false
};

const defaultReducer = createMetadataAPIReducer({ baseType: 'ANNOUNCEMENTS' });

const updatePoll = (state, pollID, answerID, currentUserID) => {
  const announcementToUpdate = Object.values(state.byId).find(
    announcement => announcement.poll && String(announcement.poll.id) === String(pollID)
  );

  if (!announcementToUpdate) return state;

  const newAnswers = announcementToUpdate.poll.answers.map(answer => {
    let voterIds = answer.voter_ids;
    if (Number(answer.id) === Number(answerID)) {
      if (!answer.voter_ids.includes(currentUserID)) {
        voterIds = answer.voter_ids.concat([currentUserID]);
      }
    } else {
      voterIds = answer.voter_ids.filter(voterId => voterId !== currentUserID);
    }

    return {
      ...answer,
      voter_ids: voterIds
    };
  });

  return {
    ...state,
    byId: {
      ...state.byId,
      [announcementToUpdate.id]: {
        ...announcementToUpdate,
        poll: {
          ...announcementToUpdate.poll,
          answers: newAnswers
        }
      }
    }
  };
};

export default (state = initialState, action) => {
  const newState = defaultReducer(state, action);

  switch (action.type) {
    case types.VOTED_FOR_POLL: {
      return updatePoll(newState, action.payload.pollID, action.payload.answerID, action.payload.currentUserID);
    }
    default: {
      return newState;
    }
  }
};
